// extracted by mini-css-extract-plugin
export default {"body":"TableBody_body__FApcR"};